import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { businessInfo } from '../mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleEmailClick = () => {
    window.location.href = `mailto:${businessInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${businessInfo.phone}`;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src={businessInfo.logo}
              alt={businessInfo.name} 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              Home
            </a>
            <a href="#services" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              Services
            </a>
            <a href="#gallery" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              Gallery
            </a>
            <a href="#about" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              About
            </a>
            <a href="#contact" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              Contact
            </a>
          </nav>

          {/* Contact Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handlePhoneClick}
              className="flex items-center space-x-2 hover:bg-gray-50 transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span>Call</span>
            </Button>
            <Button
              size="sm"
              onClick={handleEmailClick}
              className="flex items-center space-x-2 bg-gray-900 hover:bg-gray-800 transition-colors"
            >
              <Mail className="h-4 w-4" />
              <span>Email Quote</span>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-gray-900 transition-colors"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg">
            <nav className="px-4 py-4 space-y-4">
              <a href="#home" className="block text-gray-700 hover:text-gray-900 font-medium transition-colors">
                Home
              </a>
              <a href="#services" className="block text-gray-700 hover:text-gray-900 font-medium transition-colors">
                Services
              </a>
              <a href="#gallery" className="block text-gray-700 hover:text-gray-900 font-medium transition-colors">
                Gallery
              </a>
              <a href="#about" className="block text-gray-700 hover:text-gray-900 font-medium transition-colors">
                About
              </a>
              <a href="#contact" className="block text-gray-700 hover:text-gray-900 font-medium transition-colors">
                Contact
              </a>
              <div className="flex space-x-3 pt-4 border-t border-gray-200">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handlePhoneClick}
                  className="flex items-center space-x-2 flex-1"
                >
                  <Phone className="h-4 w-4" />
                  <span>Call</span>
                </Button>
                <Button
                  size="sm"
                  onClick={handleEmailClick}
                  className="flex items-center space-x-2 flex-1 bg-gray-900 hover:bg-gray-800"
                >
                  <Mail className="h-4 w-4" />
                  <span>Email</span>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;